/**
 * LogRocket Scripts Component
 * Loads LogRocket session recording based on REACT_APP_LOGROCKET_ENABLED flag
 * Consent defaults to true - no user prompt required
 */

import { useEffect, useState } from 'react';

export function LogRocketScripts() {
  const [isInitialized, setIsInitialized] = useState(false);

  const appId = process.env.REACT_APP_LOGROCKET_APP_ID;
  const logRocketEnabled = process.env.REACT_APP_LOGROCKET_ENABLED === 'true';

  // Initialize LogRocket when enabled
  useEffect(() => {
    if (
      logRocketEnabled &&
      appId &&
      !isInitialized &&
      typeof window !== 'undefined'
    ) {
      // Dynamic import for better performance
      import('./logrocket.service')
        .then(({ initLogRocket }) => {
          initLogRocket(appId);
          setIsInitialized(true);
          console.log('[LogRocket] Session recording initialized');
        })
        .catch((error) => {
          console.error('[LogRocket] Failed to initialize:', error);
        });
    }
  }, [logRocketEnabled, appId, isInitialized]);

  // Only load LogRocket when enabled with valid configuration
  if (!logRocketEnabled || !appId) {
    return null;
  }

  return null;
}

